export interface HomePage {
  data: {
    id: string;
    type: string;
    relationships?: HomePageDataRelationships[];
    attributes?: HomePageDataAttributes;
  };
  included?: HomePageIncludedItem[];
}

export interface HomePageDataAttributes {
  active: boolean;
  buttonLink: string;
  buttonLinkType: string;
  buttonText: string;
  image: string;
  mainSliderText: string;
  mainSliderTextEn: string;
  sliderSubText: string;
  sliderSubTextEn: string;
  missionHr: string | null;
  missionEn: string | null;
  visionHr: string | null;
  visionEn: string | null;
  goalsHr: string | null;
  goalsEn: string | null;
  additionalTextHr: string | null;
  additionalTextEn: string | null;
  additionalTextBulletsHr: object;
  additionalTextBulletsEn: object;
  additionalTextImage: string | null;
  tenders: number;
  calls: number;
  financeSupport: number;
  employed: number;
  statistic1: string;
  statistic2: string;
  statistic3: string;
  statistic4: string;
  statistic1En: string;
  statistic2En: string;
  statistic3En: string;
  statistic4En: string;
}

export interface HomePageDataRelationships {}

type HomePageIncludedItem =
  | HomePageIncludedPost
  | HomePageIncludedAuthenticationAccount;

export interface HomePageIncludedBase {
  type: HomePageIncludedItemType;
  id: string;
}

export interface HomePageIncludedPost extends HomePageIncludedBase {
  type: HomePageIncludedItemType.Posts;
  attributes: HomePageIncludedPostAttributes;
  relationships: {
    createdBy: {
      data: {
        id: string;
        type: HomePageIncludedItemType.AuthenticationAccounts;
      };
    };
  };
}

export interface HomePageIncludedAuthenticationAccount
  extends HomePageIncludedBase {
  type: HomePageIncludedItemType.AuthenticationAccounts;
  attributes: HomePageIncludedAuthenticationAccountsAttributes;
  relationships: [];
}

export interface HomePageIncludedPostAttributes {
  htmlContent: string;
  lastTouchTime: string;
  mainImage: string;
  slug: string;
  title: string;
}

export interface HomePageIncludedAuthenticationAccountsAttributes {
  email: string;
  firstName: string;
  lastName: string;
}

export enum HomePageIncludedItemType {
  Posts = "posts",
  AuthenticationAccounts = "authentication-accounts",
  News = 'news',
}
